import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { triggerErrorBoundaryRenderedEvent, useCreateFireAnalyticsFromTrigger } from '../../utils/analytics';
import messages from '../../utils/i18n/messages';
import { useLogger } from '../../utils/logger';
import { ErrorBoundaryBox, ErrorDescription, ErrorHeading } from './styled';
var DefaultError = function DefaultError() {
  return /*#__PURE__*/React.createElement(ErrorBoundaryBox, {
    "data-testid": "error-boundary"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://home-static.us-east-1.prod.public.atl-paas.net/robot-error.png",
    height: 200,
    width: 200,
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement(ErrorHeading, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.notificationsLoadingErrorTitle)), /*#__PURE__*/React.createElement(ErrorDescription, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.globalErrorBoundaryDescription)));
};

// eslint-disable-next-line @repo/internal/react/no-class-components
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, _) {
      var _this$props$isCritica, _this$props$logger;
      this.props.fireErrorRenderedEvent(this.props.subjectId, (_this$props$isCritica = this.props.isCritical) !== null && _this$props$isCritica !== void 0 ? _this$props$isCritica : false, this.props.notificationContext, this.props.notificationPosition);
      (_this$props$logger = this.props.logger) === null || _this$props$logger === void 0 || _this$props$logger.captureException(error, {
        source: this.props.subjectId
      });
      this.props.onErrorCallback && this.props.onErrorCallback();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return this.props.fallbackUI || /*#__PURE__*/React.createElement(DefaultError, null);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(_) {
      return {
        hasError: true
      };
    }
  }]);
  return ErrorBoundary;
}(Component); // A simple wrapper so that we can use the useCreateFireAnalyticsFromTrigger hook rather
// than using withAnalytics() + get context inside the error boundary.
var ErrorBoundaryAnalyticsWrapper = function ErrorBoundaryAnalyticsWrapper(props) {
  var fireErrorBoundaryRenderedEvent = useCreateFireAnalyticsFromTrigger(triggerErrorBoundaryRenderedEvent);
  var logger = useLogger();
  return /*#__PURE__*/React.createElement(ErrorBoundary, _extends({}, props, {
    fireErrorRenderedEvent: fireErrorBoundaryRenderedEvent,
    logger: logger
  }), props.children);
};
export default ErrorBoundaryAnalyticsWrapper;